const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
};

function paymentTiktokReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_PAYMENT_TIKTOK':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'ADMIN_PAYMENT_TIKTOK':
			return {
				...state,
				list: action?.payload?.paymenttiktoks || [],
				totalsize: action?.payload?.totalsize || 0
			};
		default:
			return state;
	}
}

export default paymentTiktokReducer;
